import { get, post } from 'services/http';

const sendSignupVerificationEmail = email => post(`/signup/verify-email`, { email });

const getVerifiedSignupEmail = token => get(`/signup/verify-email/${encodeURIComponent(token)}`);

export default { sendSignupVerificationEmail, getVerifiedSignupEmail };
